var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.panel},[_c('div',{class:_vm.$style.stepNumber,style:({color: _vm.accent})},[_vm._v(_vm._s(_vm.stepNumber)+"\n  ")]),_c('div',{class:_vm.$style.instruction},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }